import { CalendarIcon } from '@shared/assets/icons';
import { formatDate } from '@shared/libs/format-date';
import { LockedFieldLabel } from '../locked-field-label';
import styles from './locked-date-field.module.scss';

interface LockedDateFieldProps {
  label: string;
  date: Date | null;
  emptyValue?: string;
}

export const LockedDateField = ({ label, date, emptyValue = '' }: LockedDateFieldProps) => {
  return (
    <div className={styles.wrapper}>
      <LockedFieldLabel label={label} />
      <div className={styles.container}>
        <span className={styles.text}>{date ? formatDate(date.toISOString()) : emptyValue}</span>
        <span className={styles.icon}>
          <CalendarIcon />
        </span>
      </div>
    </div>
  );
};
